<template>
	<div style="flex: 1;display: flex;flex-direction: column;">
		<div class="device-mobile" v-if="isMobile" style="flex: 1;background: #F5F5F5;">
			<div class="investor">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent> 
						<span @click="toTopImg()">{{ $t('nav.home') }}</span>
						<span class="arrow">></span>
						<span @click="barClick(0)">{{ $t('nav.investor') }}</span>
						<span class="arrow">></span>
						<span v-if="list[count] && list[count].menuName">{{ list[count].menuName }}</span>
					</div>
				</div>
				<div class="tabbar">
					<div class="item" @click="barClick(index)" :class="{ active: count == index }"
						v-for="(item, index) in list">
						<div class="txt">{{ item.menuName }}</div>
						<div class="line"></div>
					</div>
				</div>
				<div class="rightMain">
					<div class="rightMainItem" v-for="(item, index) in reportList">
						<img :src="webImg + item.imgUrl + imgCut(345,253)" alt=""  @dragstart.prevent>
						<!-- <img src="../assets/2.png" alt="">
				        <img src="../assets/3.png" alt=""> -->
						<div class="rightContent">
							<div class="title txt-ellipsis-2">{{ item.contentTitle }}</div>
							<div class="time">{{ item.createTime }}</div>
							<div class="tool">
								<a :href="webImg + item.contentUrl" target="_blank"
									style="text-decoration: none;color: #333333;">
									<div class="download">
										<i class="el-icon-download"
											style="color: #0175C2;font-weight: bold;margin-right: 10px;"></i>{{ $t('common.download') }}
									</div>
								</a>
								<a :href="webImg + item.contentUrl" target="_blank"
									style="text-decoration: none;color: #333333;margin-left: auto;"
									v-if="item.contentUrl && item.contentUrl.substr(item.contentUrl.lastIndexOf('.') + 1) == 'pdf'">
									<div class="see">
										<i class="el-icon-camera-solid"
											style="color: #0175C2;font-weight: bold;margin-right: 10px;"></i>{{ $t('common.viewDetail') }}
									</div>
								</a>
								<div class="see"
									v-if="item.contentUrl && item.contentUrl.substr(item.contentUrl.lastIndexOf('.') + 1) != 'pdf'"
									@click="perview(webImg + item.contentUrl)"><i class="el-icon-camera-solid"
										style="color: #0175C2;font-weight: bold;margin-right: 10px;"></i>{{ $t('common.viewDetail') }}
								</div>
								<div class="see" @click="seeDeatil()" v-if="!item.contentUrl"><i
										class="el-icon-camera-solid"
										style="color: #0175C2;font-weight: bold;margin-right: 10px;"></i>{{ $t('common.viewDetail') }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="investor">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent> <span @click="toTopImg()"
							style="cursor: pointer;">{{ $t('nav.home') }}</span>
						<span style="color: black;">></span><span @click="barClick(0)">{{ $t('nav.investor') }}</span><span
							style="color: black;">></span><span v-if="list[count] && list[count].menuName">{{ list[count].menuName
			                }}</span>
					</div>
				</div>
				<div class="main">
					<div class="left">
						<div class="top">{{ $t('nav.investor') }}</div>
						<div v-for="(item, index) in list" class="bar" :class="{ bar1: count == index }"
							@click="barClick(index)">{{
			                item.menuName
			            }}</div>

					</div>
					<div class="right" v-if="count == 0 || count == 1">
						<div class="rightMain">
						
							<div class="rightMainItem" v-for="(item, index) in reportList">
								<img :src="webImg + item.imgUrl + imgCut(290,253)" alt=""  @dragstart.prevent>
								<!-- <img src="../assets/2.png" alt="">
			                    <img src="../assets/3.png" alt=""> -->
								<div class="rightContent">
									<div class="title">{{ item.contentTitle }}</div>
									<div class="time">{{ item.createTime }}</div>
									<div class="tool">
										<a :href="webImg + item.contentUrl" target="_blank"
											style="text-decoration: none;color: #333333;">
											<div class="download">
												<i class="el-icon-download"
													style="color: #0175C2;font-weight: bold;margin-right: 10px;"></i>{{ $t('common.download') }}
											</div>
										</a>
										<a :href="webImg + item.contentUrl" target="_blank"
											style="text-decoration: none;color: #333333;margin-left: auto;"
											v-if="item.contentUrl && item.contentUrl.substr(item.contentUrl.lastIndexOf('.') + 1) == 'pdf'">
											<div class="see">
												<i class="el-icon-camera-solid"
													style="color: #0175C2;font-weight: bold;margin-right: 10px;"></i>{{ $t('common.viewDetail') }}
											</div>
										</a>

										<div class="see"
											v-if="item.contentUrl && item.contentUrl.substr(item.contentUrl.lastIndexOf('.') + 1) != 'pdf'"
											@click="perview(webImg + item.contentUrl)"><i class="el-icon-camera-solid"
												style="color: #0175C2;font-weight: bold;margin-right: 10px;"></i>{{ $t('common.viewDetail') }}
										</div>
										<div class="see" @click="seeDeatil()" v-if="!item.contentUrl"><i
												class="el-icon-camera-solid"
												style="color: #0175C2;font-weight: bold;margin-right: 10px;"></i>{{ $t('common.viewDetail') }}
										</div>


									</div>
								</div>
							</div>
						</div>

						<div style="height: 130px;display: flex;align-items: center;justify-content: center;"
							v-if="reportList.length > 0">
							<el-pagination layout="prev, pager, next" :total="total" background :page-size="pageSize"
								@current-change="handleCurrentChange">
							</el-pagination>
						</div>

					</div>

					<div class="right" v-else style="min-height: 600px;background: #fff;padding: 10px;"
						v-html="formatRichText(text)"></div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
	import {
		menu,
		contentPage,
		singleinfo
	} from '../api/api'
	import { resolveSubMenuSelection } from '../utils/cmsNav'
	export default {
		name: 'investorTemplate',
		data() {
			return {
				list: [], //二级菜单数组
				parentId: this.$route.query.parentId || '', //二级菜单数组id
				count: 0,
				reportList: [],
				pageNum: 1,
				pageSize: 9,
				total: 0,
				menuId: '',
				text: '',
				search: '',
			}
		},
		created() {
			this.getList() //二级菜单
			this.$bus.$on('localeChanged', this.reloadData)
		},
		beforeDestroy() {
			this.$bus.$off('localeChanged', this.reloadData)
			this.$bus.$off('reachBottom');
		},
		mounted() {
			if (this.isMobile) {
				this.$bus.$on('reachBottom', data => {
					if (this.reportList.length && this.pageNum * this.pageSize < this.total) {
						this.pageNum++;
						this.getContentPage();
					} else {
						this.$message({
							message: this.$t('common.noMore'),
							center: true,
							offset: window.screen.height / 2
						});
					}
				});
			}
		},
		watch: {
			$route(to) {
				this.parentId = to.query.parentId || ''
				if (!this.list.length) {
					this.getList()
					return
				}
				const selection = resolveSubMenuSelection(this.list, to.query)
				if (selection.index === this.count) return
				this.applyRouteSelection()
			},
		},
		methods: {
			reloadData() {
				this.getList()
			},
			//首页
			toTopImg() {
				this.$router.push({
					path: '/home',
					query: {
						index: 0
					}
				})
			},
			//二级菜单
			getList() {
				menu(this.parentId).then(res => {
					this.list = res.data || []
					this.applyRouteSelection()
				})
			},
			applyRouteSelection(reload = false) {
				if (!this.list.length) return
				const selection = resolveSubMenuSelection(this.list, this.$route.query)
				this.loadMenuContent(selection.index, reload)
			},
			loadMenuContent(index, reload = false) {
				if (index === 2) {
					window.open('http://www.sse.com.cn/home/search/?webswd=600444', '_blank')
					return
				}
				const item = this.list[index]
				if (!item) return
				this.count = index
				this.menuId = item.menuId
				this.pageNum = 1
				if (reload) {
					this.reportList = []
					this.text = ''
				}
				if (index === 0 || index === 1) {
					this.getContentPage()
				} else {
					this.getSingleinfo(item.cmsLink)
				}
			},
			getContentPage() {
				contentPage(this.pageNum, this.pageSize, this.menuId, this.search, 1, 1).then(res => {
					if (!this.isMobile) {
						this.reportList = res.data;
					} else {
						if (this.pageNum == 1) {
							this.reportList = res.data;
						} else {
							this.reportList = this.reportList.concat(res.data);
						}
					}
					this.total = res.total
					console.log(this.setTwoDimensionalArray(this.reportList),
						'this.setTwoDimensionalArray(this.reportList)');
					// this.snckData = res.data
				})
			},

			barClick(index) {
				const item = this.list[index]
				if (!item) return
				if (index === 2) {
					window.open('http://www.sse.com.cn/home/search/?webswd=600444', '_blank')
					return
				}
				const isSameMenu = this.count === index
				this.loadMenuContent(index, true)
				if (!isSameMenu) {
					this.$router.replace({
						path: '/cms',
						query: {
							parentId: this.parentId,
							menuId: item.menuId,
						},
					}).catch(() => {})
				}
			},
			//富文本
			getSingleinfo(id) {
				singleinfo(id).then(res => {
					this.text = res.data.content
					console.log(res, 'getSingleinfo');
				})
			},
			handleCurrentChange(e) {
				this.pageNum = e
				this.getContentPage()
				console.log(`当前页: ${e}`);
			},
			seeDeatil() {
				this.$message(this.$t('common.noFile'))
			},
			perview(row) {
				console.log(row, 'row');

				const typeArr = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx']
				let arr = row.split('.')
				let fileType = arr[arr.length - 1]
				let url = ''
				if (typeArr.indexOf(fileType) !== -1) {
					// 使用微软的office online
					url = 'http://view.xdocin.com/xdoc?_xdoc=' + row
				} else {
					url = row.url
				}
				// window.open()居中打开
				const width = 1000;
				const height = 800
				const top = (window.screen.availHeight - height) / 2
				const left = (window.screen.availWidth - width) / 2
				window.open(url, '', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left)
			},
			formatRichText(html) { //控制富文本图片大小
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					// match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					// match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi,
						'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');

				newContent = newContent.replace(/\<img/gi,
					'<img style="max-width:95%;height:auto;display:inline-block;margin:10rpx auto;text-indent: 0;"');


				return newContent;
			},
		}
	}
</script>




<style scoped lang="scss">
	.device-mobile {
		width: 100vw;
		// display: flex;
		// justify-content: center;

		.investor {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 9.466667rem;
			margin: 0 auto;
			.navigation {
				width: 100%;
			
				// background: #F5F5F5;
				// padding: 0 0.333333rem;
				.navigationItem {
					display: flex;
					align-items: center;
					padding-top: 0.36rem;
					// height: 1.066667rem;
					color: #1979b7;
					font-size: 0.333333rem;
			
					.arrow {
						color: #030303;
						margin: 0 0.133333rem;
					}
			
					img {
						width: 0.333333rem;
						height: 0.333333rem;
						margin-right: 0.133333rem;
					}
				}
			}
			
			.tabbar {
				width: 100%;
				height: 1.653333rem;
				display: flex;
				align-items: center;

				.item {
					position: relative;
					display: flex;
					flex-direction: column;
					margin-right: 0.4rem;

					&.active {
						.txt {
							font-size: 0.453333rem;
							font-weight: bold;
							color: #000000;
						}

						.line {
							display: block;
						}
					}

					.txt {
						font-size: 0.4rem;
						font-weight: 400;
						color: #000000;
					}

					.line {
						position: absolute;
						bottom: -0.266667rem;
						display: none;
						margin-top: 0.213333rem;
						width: 1.2rem;
						height: 0.053333rem;
						background: #007CC3;
						border-radius: 0px 0px 0px 0px;
						opacity: 1;
					}
				}
			}
			
			.rightMain {
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
			
				.rightMainItem {
					display: flex;
					flex-direction: column;
					width: 4.6rem;
					height: 6.133333rem;
					background: #FFFFFF;
					box-shadow: 0px 0px 0.213333rem 0px #E0DEDF;
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
					margin-bottom: 0.266667rem;
			
					.rightContent {
						flex: 1;
						display: flex;
						flex-direction: column;
						padding: 0.266667rem;
					}
			
					img {
						width: 100%;
						height: 3.373333rem;
					}
			
					.title {
						font-size: 0.346667rem;
						font-weight: bold;
						color: #000000;
					}
			
					.time {
						font-size: 0.293333rem;
						font-weight: 500;
						color: #666666;
						margin-top: auto;
					}
			
					.tool {
						display: flex;
						font-size: 0.2rem;
						font-weight: 400;
						color: #333333;
						margin-top: 0.266667rem;
			
						.see {
							margin-left: auto;
							cursor: pointer;
						}
					}
				}
			}
		}
	}

	.device-pc {
		.investor {
			width: 100vw;
			// display: flex;
			// justify-content: center;
			background: #F5F5F5;
			padding-bottom: 50px;
		}

		.main {
			display: flex;
			width: 1300px;
			padding-top: 25px;
			margin: 0 auto;

		}

		.left {
			// background: #FFFFFF;

			.top {
				width: 270px;
				height: 64px;
				background: url('../assets/bannerImg.png') no-repeat;
				background-size: 100%;
				font-size: 26px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #FFFFFF;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.bar {
				width: 270px;
				height: 48px;
				background: #FFFFFF;
				border-bottom: 1px solid #EDEDED;
				font-size: 18px;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #333333;
				display: flex;
				justify-content: center;
				align-items: center;
				box-sizing: border-box;
				cursor: pointer;
			}

			.bar1 {
				font-size: 18px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #0175C2;
				border-bottom: 1px solid #0175C2;
			}
		}

		.right {
			width: 925px;
			margin-left: 10px;
			box-sizing: border-box;
			min-height: 600px;

			.rightMain {
				display: flex;
				flex-wrap: wrap;

				.rightMainItem {
					width: 290px;
					height: 430px;
					background: #FFFFFF;
					overflow: hidden;
					box-shadow: 0 0 16px 5px #E0DEDF;
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
					box-sizing: border-box;
					margin-bottom: 20px;
					margin-right: 15px;


					.rightContent {
						padding: 0 20px;
					}

					img {
						width: 290px;
						height: 253px;
					}

					.title {
						font-size: 19px;
						font-weight: 400;
						color: #000000;
						margin-top: 20px;
					}

					.time {
						font-size: 16px;
						font-weight: 400;
						color: #666666;
						margin-top: 12px;
					}

					.tool {
						display: flex;
						font-size: 15px;
						font-weight: 400;
						color: #333333;
						margin-top: 40px;

						.see {
							margin-left: auto;
							cursor: pointer;
						}
					}
				}
			}
		}

		.navigation {

			width: 100vw;
			background: #fff;
			display: flex;
			align-items: center;
			cursor: pointer;


			.navigationItem {
				width: 1300px;
				margin: 0 auto;
				display: flex;
				align-items: center;
				// margin-top: 15px;
				height: 36px;
				line-height: 36px;
				margin-bottom: 20px;
				padding-top: 15px;
				box-sizing: border-box;
				color: #1979b7;
				font-size: 20px;
			}

			img {
				width: 20px;
				height: 20px;
				margin-right: 7px;

			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/investor.vue